import { render, staticRenderFns } from "./StudentMainPanel.vue?vue&type=template&id=44cb8b47&scoped=true&"
import script from "./StudentMainPanel.vue?vue&type=script&lang=js&"
export * from "./StudentMainPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cb8b47",
  null
  
)

export default component.exports